import React from "react";
import { Dialog, DialogActions, DialogContent } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Trans, useTranslation } from "react-i18next";
import useRoutes, {
  getLinkComponentAttributes,
  useHistory,
} from "../hooks/useRoutes";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useShoppingCart } from "../providers/ShoppingCartProvider";
import BuyCatalogueList, { useBuyCatalogueList } from "./BuyCatalogueList";
import CatalogueIcon from "../../components/Icons/CatalogueIcon";

const useStyles = makeStyles((theme) => ({
  catalogueIconOuterContainer: {
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
  },
  catalogueIconContainer: {
    width: "100px",
    height: "85px",
    "& > svg": {
      display: "block",
    },
  },
  header: {
    color: theme.palette.primary.dark,
    margin: 0,
    textAlign: "center",
  },
}));

export default () => {
  const { handleChange, catalogues } = useBuyCatalogueList();
  const routes = useRoutes();
  const classes = useStyles();
  const { addMultipleItems } = useShoppingCart();
  const history = useHistory();

  const handleAddToCart = () => {
    console.log("Catalogues", catalogues);
    const cats = catalogues
      .filter((catalogue) => catalogue.quantity && catalogue.quantity > 0)
      .map((catalogue) => {
        return {
          catalogue,
        };
      });

    addMultipleItems(cats).then(() => {
      history.push(routes["shoppingcart"].path);
    });
  };

  const closeLink = getLinkComponentAttributes("products.list", routes);

  console.log("Close link", closeLink);

  return (
    <Dialog open={true} fullWidth="sm">
      <DialogContent>
        <div className={classes.catalogueIconOuterContainer}>
          <div className={classes.catalogueIconContainer}>
            <CatalogueIcon />
          </div>
        </div>
        <h2 className={classes.header}>
          <Trans>Do you want to order the catalogue?</Trans>
        </h2>

        {catalogues && (
          <BuyCatalogueList
            catalogues={catalogues}
            handleChange={handleChange}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button {...closeLink}>
          <Trans>No thanks</Trans>
        </Button>
        <Button color="primary" onClick={handleAddToCart}>
          <Trans>Add to cart</Trans>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
